import styled from 'styled-components';
import { Label, Container } from './Styles';

const PlusMinus = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-family: ${(props) => props.theme.fonts.sansSerif};
  font-weight: 400;
  width: 17px;
  height: 17px;
  border: 2px solid transparent;
  cursor: pointer;
  border-radius: 20px;
  margin: 3px;
  svg {
    stroke: #fff;
    fill: #fff;
  }
  background: var(--yellow);
  &:hover {
    background: ${(props) => props.theme.colors.red};
    ${Label} {
      display: flex;
    }
  }
`;

const UIContainer = styled(Container)`
  &:hover {
    ${Label} {
      display: flex;
    }
  }
  &:hover {
    ${PlusMinus} {
      background: ${(props) => props.theme.colors.red};
    }
  }
`;

const PlusMinusButton = ({ plusOrMinus = '+', clickEvent }) => (
  <UIContainer>
    <PlusMinus
      title={plusOrMinus === '+' ? 'Add to Collection' : 'Remove from Collection'}
      role="button"
      onClick={() => clickEvent()}
    >
      {plusOrMinus === '-' ? (
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="14" viewBox="0 0 24 24">
          <path d="M0 10h24v4h-24z" />
        </svg>
      ) : (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24">
          <path d="M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z" />
        </svg>
      )}
    </PlusMinus>
    {/* <Label>{plusOrMinus === '-' ? 'Remove' : 'Add'}</Label> */}
  </UIContainer>
);

export default PlusMinusButton;
// eslint-disable-next-line react/jsx-indent
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <path d="M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z" />
</svg>;
